export default __webpack_public_path__ + "statics/forbidden.96f0ebdc.png";